/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import 'react-phone-input-2/lib/style.css'
import 'react-phone-input-2/lib/bootstrap.css'


import "react-datepicker/dist/react-datepicker.css";
import { VendorList } from './VendorList';

export function Rejected() {
  return <VendorList status={2} />
}
